import axios from 'axios';
import { helperGetApiHeaders, helperConvertApiRoute, axiosErrorHandler } from 'helpers/ApiHelper';

export const FETCH_ARTICLE = 'FETCH_ARTICLE';
export const FETCH_FOX_NOW_FAQ_SCHEMA = 'FETCH_FOX_NOW_FAQ_SCHEMA';

export function fetchArticle(url, accessToken, deviceId) {
  const pageType = 'articleDetail';
  const request = axios
    .get(
      helperConvertApiRoute(url),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(axiosErrorHandler);

  return {
    type: FETCH_ARTICLE,
    payload: request,
  };
}

export const fetchFoxNowFAQSchema = () => {
  const url = window?.ExternalConfig?.structuredDataSchema;
  const request = axios.get(url).catch(axiosErrorHandler);
  return {
    type: FETCH_FOX_NOW_FAQ_SCHEMA,
    payload: request,
  };
};
